import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import './RenderRadioField.less';

const RenderRadioField = ({
  input,
  inline,
  label,
  labelElem,
  className,
  id,
  onChangeAction,
  disableDefaultAction,
  disabled,
  tooltip,
  meta: { touched, error },
}) => {
  const hasError = touched && error;
  const tooltipProp = tooltip ? { 'data-tooltip': tooltip } : {};
  const componentClassName = cn('zola-ui render-radio-field', className, {
    inline,
    'has-error': hasError,
  });
  return (
    <div className={componentClassName} {...tooltipProp}>
      <input
        {...input}
        type="radio"
        id={id}
        disabled={disabled}
        onChange={(e) => {
          if (onChangeAction) {
            onChangeAction();
          }
          if (!disableDefaultAction) {
            input.onChange(e);
          }
        }}
      />
      <label htmlFor={id}>
        {label && label}
        {labelElem && labelElem}
        {tooltip && <i className="zolaicon zolaicon-info" aria-label="Information Icon" />}
      </label>
      {touched && error && <span className="help-block error-block">{error}</span>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
};

RenderRadioField.defaultProps = {
  tooltip: '',
};

RenderRadioField.propTypes = {
  /**
   * Input information
   * name: name to group buttons
   * checked: checked a radio button
   */
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
  }).isRequired,
  /** mandatory id for label matching */
  id: PropTypes.string.isRequired,
  /** make a radio button inline-block */
  inline: PropTypes.bool,
  /** label for the radio button */
  label: PropTypes.string,
  /** React Element as a label for the radio button */
  labelElem: PropTypes.element,
  /** type of the input */
  type: PropTypes.oneOf(['radio']).isRequired,
  /** custom function that triggered by onChange event of the input */
  onChangeAction: PropTypes.func,
  /** disable default action for onChange event of the input */
  disableDefaultAction: PropTypes.bool,
  /** custom class name */
  className: PropTypes.string,
  /** disable the radio button
   * NOTE: Currently, you much have to manfully disable all buttons in the same group
   * to make CSS hover style consist.
   * */
  disabled: PropTypes.bool,
  /** NOTE: it still uses bootstrap to handle tooltip at the moment */
  tooltip: PropTypes.string,
  /** This prop is provided by Redux Form directly.  */
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

export default RenderRadioField;
